import { isFunction, noopReturn } from '@motionone/utils';
import { updateScrollInfo } from './info.es.js';
import { resolveOffsets } from './offsets/index.es.js';
function _measure(container) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
  var info = arguments.length > 2 ? arguments[2] : undefined;
  /**
   * Find inset of target within scrollable container
   */
  info.x.targetOffset = 0;
  info.y.targetOffset = 0;
  if (target !== container) {
    var node = target;
    while (node && node != container) {
      info.x.targetOffset += node.offsetLeft;
      info.y.targetOffset += node.offsetTop;
      node = node.offsetParent;
    }
  }
  info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
  info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
  info.x.containerLength = container.clientWidth;
  info.y.containerLength = container.clientHeight;
}
function createOnScrollHandler(element, onScroll, info) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var axis = options.axis || "y";
  return {
    measure: function measure() {
      return _measure(element, options.target, info);
    },
    update: function update(time) {
      updateScrollInfo(element, info, time);
      if (options.offset || options.target) {
        resolveOffsets(element, info, options);
      }
    },
    notify: isFunction(onScroll) ? function () {
      return onScroll(info);
    } : scrubAnimation(onScroll, info[axis])
  };
}
function scrubAnimation(controls, axisInfo) {
  controls.pause();
  controls.forEachNative(function (animation, _ref) {
    var easing = _ref.easing;
    var _a, _b;
    if (animation.updateDuration) {
      if (!easing) animation.easing = noopReturn;
      animation.updateDuration(1);
    } else {
      var timingOptions = {
        duration: 1000
      };
      if (!easing) timingOptions.easing = "linear";
      (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 ? void 0 : _b.call(_a, timingOptions);
    }
  });
  return function () {
    controls.currentTime = axisInfo.progress;
  };
}
export { createOnScrollHandler };